export const getLocaleDateString = () => {
  const formats = {
    'af-ZA': 'yyyy/MM/DD',
    'am-ET': 'D/M/yyyy',
    'ar-AE': 'DD/MM/yyyy',
    'ar-BH': 'DD/MM/yyyy',
    'ar-DZ': 'DD-MM-yyyy',
    'ar-EG': 'DD/MM/yyyy',
    'ar-IQ': 'DD/MM/yyyy',
    'ar-JO': 'DD/MM/yyyy',
    'ar-KW': 'DD/MM/yyyy',
    'ar-LB': 'DD/MM/yyyy',
    'ar-LY': 'DD/MM/yyyy',
    'ar-MA': 'DD-MM-yyyy',
    'ar-OM': 'DD/MM/yyyy',
    'ar-QA': 'DD/MM/yyyy',
    'ar-SA': 'DD/MM/yy',
    'ar-SY': 'DD/MM/yyyy',
    'ar-TN': 'DD-MM-yyyy',
    'ar-YE': 'DD/MM/yyyy',
    'arn-CL': 'DD-MM-yyyy',
    'as-IN': 'DD-MM-yyyy',
    'az-Cyrl-AZ': 'DD.MM.yyyy',
    'az-Latn-AZ': 'DD.MM.yyyy',
    'ba-RU': 'DD.MM.yy',
    'be-BY': 'DD.MM.yyyy',
    'bg-BG': 'DD.M.yyyy',
    'bn-BD': 'DD-MM-yy',
    'bn-IN': 'DD-MM-yy',
    'bo-CN': 'yyyy/M/D',
    'br-FR': 'DD/MM/yyyy',
    'bs-Cyrl-BA': 'D.M.yyyy',
    'bs-Latn-BA': 'D.M.yyyy',
    'ca-ES': 'DD/MM/yyyy',
    'co-FR': 'DD/MM/yyyy',
    'cs-CZ': 'D.M.yyyy',
    'cy-GB': 'DD/MM/yyyy',
    'da-DK': 'DD-MM-yyyy',
    'de-AT': 'DD.MM.yyyy',
    'de-CH': 'DD.MM.yyyy',
    'de-DE': 'DD.MM.yyyy',
    'de-LI': 'DD.MM.yyyy',
    'de-LU': 'DD.MM.yyyy',
    'dsb-DE': 'D. M. yyyy',
    'dv-MV': 'DD/MM/yy',
    'el-GR': 'D/M/yyyy',
    'en-029': 'MM/DD/yyyy',
    'en-AU': 'D/MM/yyyy',
    'en-BZ': 'DD/MM/yyyy',
    'en-CA': 'DD/MM/yyyy',
    'en-GB': 'DD/MM/yyyy',
    'en-IE': 'DD/MM/yyyy',
    'en-IN': 'DD-MM-yyyy',
    'en-JM': 'DD/MM/yyyy',
    'en-MY': 'D/M/yyyy',
    'en-NZ': 'D/MM/yyyy',
    'en-PH': 'M/D/yyyy',
    'en-SG': 'D/M/yyyy',
    'en-TT': 'DD/MM/yyyy',
    'en-US': 'M/D/yyyy',
    'en-ZA': 'yyyy/MM/DD',
    'en-ZW': 'M/D/yyyy',
    'es-AR': 'DD/MM/yyyy',
    'es-BO': 'DD/MM/yyyy',
    'es-CL': 'DD-MM-yyyy',
    'es-CO': 'DD/MM/yyyy',
    'es-CR': 'DD/MM/yyyy',
    'es-DO': 'DD/MM/yyyy',
    'es-EC': 'DD/MM/yyyy',
    'es-ES': 'DD/MM/yyyy',
    'es-GT': 'DD/MM/yyyy',
    'es-HN': 'DD/MM/yyyy',
    'es-MX': 'DD/MM/yyyy',
    'es-NI': 'DD/MM/yyyy',
    'es-PA': 'MM/DD/yyyy',
    'es-PE': 'DD/MM/yyyy',
    'es-PR': 'DD/MM/yyyy',
    'es-PY': 'DD/MM/yyyy',
    'es-SV': 'DD/MM/yyyy',
    'es-US': 'M/D/yyyy',
    'es-UY': 'DD/MM/yyyy',
    'es-VE': 'DD/MM/yyyy',
    'et-EE': 'D.MM.yyyy',
    'eu-ES': 'yyyy/MM/DD',
    'fa-IR': 'MM/DD/yyyy',
    'fi-FI': 'D.M.yyyy',
    'fil-PH': 'M/D/yyyy',
    'fo-FO': 'DD-MM-yyyy',
    'fr-BE': 'D/MM/yyyy',
    'fr-CA': 'yyyy-MM-DD',
    'fr-CH': 'DD.MM.yyyy',
    'fr-FR': 'DD/MM/yyyy',
    'fr-LU': 'DD/MM/yyyy',
    'fr-MC': 'DD/MM/yyyy',
    'fy-NL': 'd-M-yyyy',
    'ga-IE': 'DD/MM/yyyy',
    'gd-GB': 'DD/MM/yyyy',
    'gl-ES': 'DD/MM/yy',
    'gsw-FR': 'DD/MM/yyyy',
    'gu-IN': 'DD-MM-yy',
    'ha-Latn-NG': 'D/M/yyyy',
    'he-IL': 'DD/MM/yyyy',
    'hi-IN': 'DD-MM-yyyy',
    'hr-BA': 'D.M.yyyy.',
    'hr-HR': 'D.M.yyyy',
    'hsb-DE': 'D. M. yyyy',
    'hu-HU': 'yyyy. MM. DD.',
    'hy-AM': 'DD.MM.yyyy',
    'id-ID': 'DD/MM/yyyy',
    'ig-NG': 'D/M/yyyy',
    'ii-CN': 'yyyy/M/D',
    'is-IS': 'D.M.yyyy',
    'it-CH': 'DD.MM.yyyy',
    'it-IT': 'DD/MM/yyyy',
    'iu-Cans-CA': 'D/M/yyyy',
    'iu-Latn-CA': 'D/MM/yyyy',
    'ja-JP': 'yyyy/MM/DD',
    'ka-GE': 'DD.MM.yyyy',
    'kk-KZ': 'DD.MM.yyyy',
    'kl-GL': 'DD-MM-yyyy',
    'km-KH': 'yyyy-MM-DD',
    'kn-IN': 'DD-MM-yy',
    'ko-KR': 'yyyy. MM. DD',
    'kok-IN': 'DD-MM-yyyy',
    'ky-KG': 'DD.MM.yy',
    'lb-LU': 'DD/MM/yyyy',
    'lo-LA': 'DD/MM/yyyy',
    'lt-LT': 'yyyy.MM.DD',
    'lv-LV': 'yyyy.MM.DD.',
    'mi-NZ': 'DD/MM/yyyy',
    'mk-MK': 'DD.MM.yyyy',
    'ml-IN': 'DD-MM-yy',
    'mn-MN': 'yy.MM.DD',
    'mn-Mong-CN': 'yyyy/M/D',
    'moh-CA': 'M/D/yyyy',
    'mr-IN': 'DD-MM-yyyy',
    'ms-BN': 'DD/MM/yyyy',
    'ms-MY': 'DD/MM/yyyy',
    'mt-MT': 'DD/MM/yyyy',
    'nb-NO': 'DD.MM.yyyy',
    'ne-NP': 'M/D/yyyy',
    'nl-BE': 'D/MM/yyyy',
    'nl-NL': 'd-M-yyyy',
    'nn-NO': 'DD.MM.yyyy',
    'nso-ZA': 'yyyy/MM/DD',
    'oc-FR': 'DD/MM/yyyy',
    'or-IN': 'DD-MM-yy',
    'pa-IN': 'DD-MM-yy',
    'pl-PL': 'DD.MM.yyyy',
    'prs-AF': 'DD/MM/yy',
    'ps-AF': 'DD/MM/yy',
    'pt-BR': 'D/M/yyyy',
    'pt-PT': 'DD-MM-yyyy',
    'qut-GT': 'DD/MM/yyyy',
    'quz-BO': 'DD/MM/yyyy',
    'quz-EC': 'DD/MM/yyyy',
    'quz-PE': 'DD/MM/yyyy',
    'rm-CH': 'DD/MM/yyyy',
    'ro-RO': 'DD.MM.yyyy',
    'ru-RU': 'DD.MM.yyyy',
    'rw-RW': 'M/D/yyyy',
    'sa-IN': 'DD-MM-yyyy',
    'sah-RU': 'MM.DD.yyyy',
    'se-FI': 'D.M.yyyy',
    'se-NO': 'DD.MM.yyyy',
    'se-SE': 'yyyy-MM-DD',
    'si-LK': 'yyyy-MM-DD',
    'sk-SK': 'D. M. yyyy',
    'sl-SI': 'D.M.yyyy',
    'sma-NO': 'DD.MM.yyyy',
    'sma-SE': 'yyyy-MM-DD',
    'smj-NO': 'DD.MM.yyyy',
    'smj-SE': 'yyyy-MM-DD',
    'smn-FI': 'D.M.yyyy',
    'sms-FI': 'D.M.yyyy',
    'sq-AL': 'yyyy-MM-DD',
    'sr-Cyrl-BA': 'D.M.yyyy',
    'sr-Cyrl-CS': 'D.M.yyyy',
    'sr-Cyrl-ME': 'D.M.yyyy',
    'sr-Cyrl-RS': 'D.M.yyyy',
    'sr-Latn-BA': 'D.M.yyyy',
    'sr-Latn-CS': 'D.M.yyyy',
    'sr-Latn-ME': 'D.M.yyyy',
    'sr-Latn-RS': 'D.M.yyyy',
    'sv-FI': 'D.M.yyyy',
    'sv-SE': 'yyyy-MM-DD',
    'sw-KE': 'M/D/yyyy',
    'syr-SY': 'DD/MM/yyyy',
    'ta-IN': 'DD-MM-yyyy',
    'te-IN': 'DD-MM-yy',
    'tg-Cyrl-TJ': 'DD.MM.yy',
    'th-TH': 'D/M/yyyy',
    'tk-TM': 'DD.MM.yy',
    'tn-ZA': 'yyyy/MM/DD',
    'tr-TR': 'DD.MM.yyyy',
    'tt-RU': 'DD.MM.yyyy',
    'tzm-Latn-DZ': 'DD-MM-yyyy',
    'ug-CN': 'yyyy-M-d',
    'uk-UA': 'DD.MM.yyyy',
    'ur-PK': 'DD/MM/yyyy',
    'uz-Cyrl-UZ': 'DD.MM.yyyy',
    'uz-Latn-UZ': 'DD/MM yyyy',
    'vi-VN': 'DD/MM/yyyy',
    'wo-SN': 'DD/MM/yyyy',
    'xh-ZA': 'yyyy/MM/DD',
    'yo-NG': 'D/M/yyyy',
    'zh-CN': 'yyyy/M/D',
    'zh-HK': 'D/M/yyyy',
    'zh-MO': 'D/M/yyyy',
    'zh-SG': 'D/M/yyyy',
    'zh-TW': 'yyyy/M/D',
    'zu-ZA': 'yyyy/MM/DD',
  };

  return formats[navigator.language] || 'DD/MM/yyyy';
};
